import { Injectable } from '@angular/core';

import * as listMembersActions from './list-members.actions';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { exhaustMap, map, take } from 'rxjs/operators';
import { ListMembersService } from '../../services/list-members/list-members.service';
import { Observable } from 'rxjs';

@Injectable()
export class ListMemberEffects {
  constructor(private actions$: Actions, private listMembersService: ListMembersService) {
  }

  listMember$ = createEffect(() =>
  this.actions$.pipe(
    ofType(listMembersActions.listMembersSearch),
    exhaustMap((action) =>
      this.listMembersService.listMembersHash(action.stringSearch).pipe(
        map(response => {
          return listMembersActions.listMembersSearchSuccess({ memberList: response});
        })
      )
    )
  ));

  resetList$ = createEffect(() =>
  this.actions$.pipe(
      ofType(listMembersActions.listMemberReset),
      exhaustMap(() =>
          new Observable<any>(observable => observable.next(true)).pipe(
              take(1),
              map(() => {
                return listMembersActions.listMemberResetSuccess();
              }))
      )
    )
  );
}
